import type { GetUngatedPaginatedShopCategoryQuery } from './getUngatedPaginatedShopCategory';
type Category = NonNullable<NonNullable<NonNullable<GetUngatedPaginatedShopCategoryQuery['shopContent']>['categoryPage']>['category']>;
type FixTheme = NonNullable<GetUngatedPaginatedShopCategoryQuery['fixTheme']>;
export type ShopProductSource = {
  kind: 'category';
  connection: Category['shopProducts'];
} | {
  kind: 'theme';
  connection: FixTheme['shopProducts'];
  themeId: string;
};
export type ShopProductSourceType = 'category' | 'theme';
export const getShopProductSourceForType = (data: GetUngatedPaginatedShopCategoryQuery | undefined, sourceType: ShopProductSourceType): ShopProductSource | undefined => {
  if (sourceType === 'category') {
    const category = data?.shopContent?.categoryPage?.category;
    return category ? {
      kind: 'category',
      connection: category.shopProducts
    } : undefined;
  }
  if (sourceType === 'theme') {
    const theme = data?.fixTheme;
    return theme ? {
      kind: 'theme',
      connection: theme.shopProducts,
      themeId: theme.id
    } : undefined;
  }
  return undefined;
};